import { createContext, useContext } from 'react'
import {
  SchedulerContextProps,
  SchedulerStateActions,
} from '../types'
import { UseSchedulerRangeMemoState } from './useCalculateSchedulerRangeData.ts'
import { ScheduleProviderPropsWithDefaults } from './SchedulerProviderProps'

export const SchedulerContext =
  createContext<SchedulerContextProps>(
    {} as any // Set immediately within SchedulerProvider
  )
SchedulerContext.displayName = 'SchedulerContext'

export const useSchedulerContext = (): SchedulerContextProps => {
  return useContext(SchedulerContext)
}
export const SchedulerDispatchContext =
  createContext<SchedulerStateActions>(null as any)
SchedulerDispatchContext.displayName = 'SchedulerDispatchContext'

export const useSchedulerDispatchContext =
  (): SchedulerStateActions => {
    return useContext(SchedulerDispatchContext)
  }

export const SchedulerPropsContext =
  createContext<ScheduleProviderPropsWithDefaults>(null as any)
SchedulerPropsContext.displayName = 'SchedulerPropsContext'

export const useSchedulerPropsContext = () => {
  return useContext(SchedulerPropsContext)
}

export const SchedulerRangeDataContext =
  createContext<UseSchedulerRangeMemoState>({} as any)

export const useSchedulerRangeData = () =>
  useContext(SchedulerRangeDataContext)
